module.exports = __webpack_public_path__ + "static/img/tool_edit_box01.bc1f9db8.png";